module.exports = __webpack_public_path__ + "static/media/blue_icon.6c47b3a5.svg";